import React, { useState, useEffect, useContext } from "react";
import VerticalNavigation from "../components/VerticalNavigation";
import Dropdown from "../components/Dropdown";
import AuthContext from "../context/AuthContext";
import "../css/featureEngineering.css";
import PcaPlot from "../components/PcaPlot";
import Swal from "sweetalert2";

const FeatureEngineering = () => {
  const Swal = require('sweetalert2');
  const { authTokens } = useContext(AuthContext);

  const scaling_attrs = [
    {
      value: "select",
      label: "--Select--",
    },
    { value: "min-max", label: "Min-Max Scaling" },
  ];
  const transf_attrs = [
    {
      value: "select",
      label: "--Select--",
    },
    {
      value: "std",
      label: "Standization",
    },
    {
      value: "box-cox",
      label: "Box-Cox Transformation",
    },
  ];
  const reduce_attrs = [
    {
      value: "select",
      label: "--Select--",
    },
    {
      value: "pca",
      label: "Principal Component Analysis",
    },
    {
      value: "tsne",
      label: "t-SNE",
    },
    {
      value: "umap",
      label: "UMAP",
    },
    {
      value: "lda",
      label: "Linear Dicriminant Analysis",
    },
  ];

  // scaling
  const initscale = scaling_attrs[0].label;
  const [scaleAttribute, setscaleAttribute] = useState(initscale);

  //transformation
  const inittrans = transf_attrs[0].label;
  const [transAttribute, settransAttribute] = useState(inittrans);

  const [scadata, setScaData] = useState(null);

  //reduction
  const initreduc = reduce_attrs[0].label;
  const [reducAttribute, setreducAttribute] = useState(initreduc);
  const [pcadata, setPCAdata] = useState(null);

  //checkbox
  const [selectcols, setSelectColumns] = useState({
    columns: [],
  });

  const handleOnChange = (e) => {
    const { value, checked } = e.target;
    const { columns } = selectcols;
    //case 1 checked
    if (checked) {
      setSelectColumns({
        columns: [...columns, value],
      });
    }
    //case 2: unchecked
    else {
      setSelectColumns({
        columns: columns.filter((e) => e !== value),
      });
    }
  };

  ///
  useEffect(() => {
    featureEngineering();
  });

  let featureEngineering = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/feature_engineering/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
    });
    const data = await response.json();
    if (response.status === 200) {
      setScaData(data);
    }
  };

  let featureScaling = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/feature_sacaling/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({scaleAttribute}),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:'Success',
        text:'Feature engineering have Done!!!.',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      if (data["Status"] === "Already Done") {
        // alert(data["Msg"]);
        Swal.fire({
          title:'Success',
          text:'Feature engineering have Done!!!.',
          icon: 'info',
          confirmButtonText: 'Ok'
        })
      } else if (data["Status"] === "Failed") {
        // alert(data["Error"]);
        Swal.fire({
          title:'Error',
          text:"Something Wrong!",
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      } else {
        setScaData(data);
      }
    }
  };
  let featurereduction = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/feature_reduction/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ operation: { reducAttribute } }),
    });
    const fdata = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:'Success',
        text:'Feature Reduction have done!!!.',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      // console.log("Feature Reduction..");
      if (fdata["Status"] === "Failed") {
        // alert(fdata["Error"]);
        Swal.fire({
          title:'Error',
          text:'Something Wrong!!!.',
          icon: 'success',
          confirmButtonText: 'Ok'
        })
      } else {
        setPCAdata(fdata.data);
      }
    }
  };

  let featureTransformation = async () => {
    let response = await fetch(
      `${process.env.REACT_APP_URL}/feature_transformation/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + String(authTokens.access),
        },
        body: JSON.stringify({ operation: { transAttribute } }),
      }
    );
    const tdata = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:'Success',
        text:'Feature Transformation have done!',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      console.log("Feature Transformation");
      if (tdata["Status"] === "Already Done") {
        // alert(tdata["Msg"]);
        Swal.fire({
          title:'Info',
          text:'Feature Transformation already have done!!!.',
          icon: 'info',
          confirmButtonText: 'Ok'
        })
      } else if (tdata["Status"] === "Failed") {
        // alert(tdata["Error"]);
        Swal.fire({
          title:'Error',
          text:'Something Wrong!!!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      } else if (tdata.data) {
        setScaData(tdata);
      }
    }
  };
  // console.log("state",reducAttribute);

  let selectfeature = async (e) => {
    e.preventDefault();
    let response = await fetch(`${process.env.REACT_APP_URL}/feature_selection/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({
        selectcols,
      }),
    });
    let data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:'Success',
        text:'Feature Selection have done!!!',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      // console.log("Features Selection done......");
      if (data["Status"] === "Already Done") {
        // alert(data["Msg"]);
        Swal.fire({
          title:'Info',
          text:"Feature Selection already have done!!!.",
          icon: 'info',
          confirmButtonText: 'Ok'
        })
      } else if (data["Status"] === "Failed") {
        // alert(data["Error"]);
        Swal.fire({
          title:'Error',
          text: 'Something Wrong!!!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
      else if (data['Status'] === 'Done'){
        alert(data['Msg']);
      }
    }
  };

  ///hocks
  useEffect(() => {
    featureScaling();
  }, [scaleAttribute]);

  useEffect(() => {
    featurereduction();
  }, [reducAttribute]);

  useEffect(() => {
    featureTransformation();
  }, [transAttribute]);

  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        <div className="container bg-light rounded main_content mx-2">
          <div className="model-body">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#fselect"
                  role="tab"
                >
                  <spam className="d-none d-sm-block">Feature Selection</spam>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#scale"
                  role="tab"
                >
                  <spam className="d-none d-sm-block">Feature Scaling</spam>
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#exctr"
                  role="tab"
                >
                  <spam className="d-none d-sm-block">Feature Exctraction</spam>
                </a>
              </li> */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#transf"
                  role="tab"
                >
                  <spam className="d-none d-sm-block">
                    Feature Transformation
                  </spam>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#reduc"
                  role="tab"
                >
                  <spam className="d-none d-sm-block">Feature Reduction</spam>
                </a>
              </li>
            </ul>

            <div className="tab-content p-3">
              <div className="tab-pane active" id="fselect" role="tabpanel">
                <h3 className="text-center">Select Your Features.</h3>
                <br />
                {scadata && (
                  <>
                    <div
                      className="row row-cols-1 row-cols-md-3 g-4 my-5"
                      style={{ flexDirection: "row" }}
                    >
                      {scadata["features"].map((itm, ind) => (
                        <div className="col">
                          <h5>{itm}:</h5>
                          <input
                            type="checkbox"
                            name={"withIndex." + ind}
                            value={itm}
                            onChange={handleOnChange}
                          ></input>
                        </div>
                      ))}

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-success"
                          onClick={selectfeature}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="tab-pane" id="scale" role="tabpanel">
                <div className="">
                  <h3>Feature Scaling</h3>&nbsp;&nbsp;&nbsp;&nbsp;
                  <Dropdown
                    options={scaling_attrs}
                    id="scale"
                    selectedValue={scaleAttribute}
                    onSelectedValueChange={setscaleAttribute}
                  />
                  <br />
                  {scadata && (
                    <div className="table-fixedhead">
                    <table className="table-bordered px-3">
                      <thead>
                        {scadata["features"].map((itm) => (
                          <th scope="col">{itm}</th>
                        ))}
                      </thead>
                      <tbody>
                        {scadata.data.slice(1, 10).map((itm) => (
                          <tr>
                            {itm.map((it) => (
                              <td>{it}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  )}
                </div>
              </div>

              <div className="tab-pane" id="exctr" role="tabpanel">
                <h3 className="text-center">Feature Extraction</h3>
              </div>

              <div className="tab-pane" id="transf" role="tabpanel">
                <div className="d-flex">
                  <h3>Feature Transformation</h3>&nbsp;&nbsp;&nbsp;&nbsp;
                  <Dropdown
                    options={transf_attrs}
                    id="trans"
                    selectedValue={transAttribute}
                    onSelectedValueChange={settransAttribute}
                  />
                </div>
                <br />
                <div className="my-5">
                  {scadata && (
                    <div className="table-fixedhead">
                    <table className="table-bordered px-3">
                      <thead>
                        {scadata["features"].map((itm) => (
                          <th scope="col">{itm}</th>
                        ))}
                      </thead>
                      <tbody>
                        {scadata.data.slice(1, 10).map((itm) => (
                          <tr>
                            {itm.map((it) => (
                              <td>{it}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  )}
                </div>
              </div>

              <div className="tab-pane" id="reduc" role="tabpanel">
                <h3 className="text-center">Feature Reduction</h3>
                <div className="d-flex">
                  <div className="mt-5">
                    <p>Select One Technique:</p>
                    <Dropdown
                      options={reduce_attrs}
                      id="scale"
                      selectedValue={reducAttribute}
                      onSelectedValueChange={setreducAttribute}
                    />
                  </div>
                  <div className="vertical-line"></div>
                  <div className="mx-5">
                    {pcadata && <PcaPlot fdata={pcadata} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeatureEngineering;
